// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.token-error-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: var(--warning-light);
  border: 1px solid var(--warning-border);
  border-top: none;
  z-index: var(--z-fixed);
  box-shadow: var(--shadow-md);
}

.token-error-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-md) var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
}

.token-error-message {
  color: #856404;
  font-weight: var(--font-medium);
}

.token-error-actions {
  display: flex;
  gap: var(--spacing-sm);
}

@media (max-width: 768px) {
  .token-error-content {
    flex-direction: column;
    gap: var(--spacing-sm);
    text-align: center;
  }
  
  .token-error-actions {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,gCAAgC;EAChC,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4CAA4C;EAC5C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".App {\r\n  text-align: center;\r\n}\r\n\r\n.token-error-banner {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background: var(--warning-light);\r\n  border: 1px solid var(--warning-border);\r\n  border-top: none;\r\n  z-index: var(--z-fixed);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.token-error-content {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: var(--spacing-md) var(--spacing-lg);\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.token-error-message {\r\n  color: #856404;\r\n  font-weight: var(--font-medium);\r\n}\r\n\r\n.token-error-actions {\r\n  display: flex;\r\n  gap: var(--spacing-sm);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .token-error-content {\r\n    flex-direction: column;\r\n    gap: var(--spacing-sm);\r\n    text-align: center;\r\n  }\r\n  \r\n  .token-error-actions {\r\n    justify-content: center;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
